import type { BaserowMCQRow } from '../../types/baserow';
import type { MCQ } from '../../types/mcq';

export function transformBaserowRow(row: BaserowMCQRow): MCQ {
  const tags = Array.isArray(row.Tags) 
    ? row.Tags.map(tag => tag.value)
    : [];

  return {
    id: row.id,
    mcqId: row.MCQID,
    question: row.Question,
    optionA: row['Option A'],
    optionB: row['Option B'],
    optionC: row['Option C'],
    optionD: row['Option D'],
    answer: row.Answer?.value || '',
    topic: row.Topic?.value || '',
    subtopic: row.SubTopic?.value || '',
    fullMcq: row['Full MCQ'] || '',
    isDuplicate: row.Duplicate || false,
    isCompared: row.Compared || false,
    toReview: row['To Review'] || false,
    tags: tags,
    similarityScore: undefined,
    takeaway: row.Takeaway || ''
  };
}

export function transformToBaserowRow(mcq: Partial<MCQ>): Partial<BaserowMCQRow> {
  const baserowData: Partial<BaserowMCQRow> = {};

  // Map basic fields
  if (mcq.question !== undefined) baserowData.Question = mcq.question;
  if (mcq.optionA !== undefined) baserowData['Option A'] = mcq.optionA;
  if (mcq.optionB !== undefined) baserowData['Option B'] = mcq.optionB;
  if (mcq.optionC !== undefined) baserowData['Option C'] = mcq.optionC;
  if (mcq.optionD !== undefined) baserowData['Option D'] = mcq.optionD;
  if (mcq.takeaway !== undefined) baserowData.Takeaway = mcq.takeaway;
  
  // Map boolean fields
  if (mcq.isDuplicate !== undefined) baserowData.Duplicate = mcq.isDuplicate;
  if (mcq.isCompared !== undefined) baserowData.Compared = mcq.isCompared;
  if (mcq.toReview !== undefined) baserowData['To Review'] = mcq.toReview;

  // For single select fields, we'll handle the ID mapping in the API layer
  if (mcq.answer !== undefined) baserowData.Answer = mcq.answer;
  if (mcq.topic !== undefined) baserowData.Topic = mcq.topic;
  if (mcq.subtopic !== undefined) baserowData.SubTopic = mcq.subtopic;

  return baserowData;
}